import React from "react";
import { useHistory } from "react-router-dom";
import BookingSummary from "../components/BookingSummary";
import { bulkLockerReserver } from "../api/api";
import { generateReserveTiming, getPathForNextPage, handleBulkReservationPayment } from "../lib/Utils";
import { LOCAL_STORAGE } from "../assets/constants/BrowserStorageKeys";
import { getSecureItemFromSpecificStorage } from "../lib/BrowserStorageAccessMiddleware";
import { BOOKING_SUMMARY, LOCKER_SIZE_SELECTION, LOGIN } from "../assets/constants/PageList";

const BookingSummaryPage = () => {
  const history = useHistory();
  const state = history.location?.state || {};

  const {
    selectedLockers = [],
    address = "puna lulla nagar",
    lockerCurrency = "INR",
    bookingTimingObject = [],
    lockerBankId = null,
    assignmentSlug = null,
    locker_bank_slug = null,
    IsAdvanceBooking = false,
  } = state;

  const resolvedCurrency =
    lockerCurrency && lockerCurrency !== "null"
      ? lockerCurrency
      : selectedLockers?.[0]?.currency || "INR";

  const handleEditSelection = () => {
    history.replace({
      pathname: getPathForNextPage(BOOKING_SUMMARY, LOCKER_SIZE_SELECTION),
      state: {
        ...state,
        selectedLockers,
      },
    });
  };

  const handleLockerBooking = async (lockers = null, total = null) => {
    const finalLockers = lockers || selectedLockers;
    const finalTotal = total ?? 0;

    let allocationData = [];

    if (finalLockers[0]?.selectedSlot && finalLockers[0]?.bookingSlots) {
      allocationData = finalLockers.map((locker) => ({
        door_size: locker.door_size,
        price: Number(locker?.selectedSlot?.price || 0),
        slot_id: locker?.selectedSlot?.id || null,
      }));
    } else {
      allocationData = finalLockers.map((locker) => ({
        door_size: locker.door_size,
        price: Number(locker.price || 0),
        slot_id: locker.slot_id || null,
      }));
    }

    const timingData =
      bookingTimingObject && Object.keys(bookingTimingObject).length > 0
        ? bookingTimingObject
        : generateReserveTiming(6);

    const bookingObject = {
      ...timingData,
      allocation_method: "automatic_allocation",
      allocation_data: allocationData,
      total_price: finalTotal,
      locker_bank_id: lockerBankId,
      locker_bank_slug: locker_bank_slug
        ? locker_bank_slug
        : getSecureItemFromSpecificStorage(LOCAL_STORAGE, "locker_slug"),
      assignmentSlug: assignmentSlug,
    };

    if (IsAdvanceBooking) {
      history.push({
        pathname: getPathForNextPage(BOOKING_SUMMARY, LOGIN),
        state: {
          bookingObject: bookingObject,
        },
      });
    } else {
      const reserveLockerResponse = await bulkLockerReserver(bookingObject);
      await handleBulkReservationPayment(reserveLockerResponse, history, {
        isAdvanceBooking: IsAdvanceBooking,
      });
    }
  };

  return (
    <div className="booking-summary-page">
      <div className="locker-summary-container">
        <BookingSummary
          lockerCurrency={resolvedCurrency}
          bookingLockerHandler={handleEditSelection}
          selectedLockers={selectedLockers}
          address={address}
          handleLockerBooking={handleLockerBooking}
        />
      </div>
    </div>
  );
};

export default BookingSummaryPage;
